"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../../core/commons");

var BaselineInfo_1 = require("../model/BaselineInfo");

var BaselineInfoConverter_1 = require("./BaselineInfoConverter");
/**
 * @author VRu
 */


var BaselineInfoConverterImpl =
/*#__PURE__*/
function (_BaselineInfoConverte) {
  _inherits(BaselineInfoConverterImpl, _BaselineInfoConverte);

  function BaselineInfoConverterImpl() {
    _classCallCheck(this, BaselineInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaselineInfoConverterImpl).apply(this, arguments));
  }

  _createClass(BaselineInfoConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new BaselineInfo_1.BaselineInfo(BaselineInfo_1.BaselineInfo.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), BaselineInfo_1.BaselineInfo.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), BaselineInfo_1.BaselineInfo.schema.date.valueOfField(source), BaselineInfo_1.BaselineInfo.schema.amount.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return commons_1.UNIMPLEMENTED("To document should not be needed. Use baseline entity instead.");
    }
  }]);

  return BaselineInfoConverterImpl;
}(BaselineInfoConverter_1.BaselineInfoConverter);

exports.BaselineInfoConverterImpl = BaselineInfoConverterImpl;